import { Behavior, AttachmentRule } from './types';

export class ColorCycleBehavior extends Behavior {
  static getAttachmentRules(): AttachmentRule[] {
    return [
      { type: 'class', selector: 'colorcycle' },
      { type: 'class', selector: 'color-cycle' },
      // { type: 'element', selector: 'm-sphere' } // Automatically attach to all spheres
    ];
  }

  onAttach(): void {
    console.log('ColorCycleBehavior attached to:', this.element);
    
    // Array of named HTML colors
    const colors = ['red', 'blue', 'green', 'yellow', 'purple', 'orange', 'pink', 'cyan', 'magenta', 'lime', 'indigo', 'violet', 'brown', 'gray', 'black', 'white', 'navy', 'teal', 'olive', 'maroon'];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    
    this.element.setAttribute('color', randomColor);
  }

  onDetach(): void {
    console.log('ColorCycleBehavior detached from:', this.element);
    // Reset color when detaching
    this.element.removeAttribute('color');
  }
} 